module.exports = __webpack_public_path__ + "static/djinni-6a83ae4ba55114bb4a26699cce634a66.jpg";